import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/wiki',
    component: () => import('@/views/wiki/index.vue'),
    meta: {
      layout: 'share'
    },
    children: [
      {
        path: ':sid',
        name: 'wikiHome',
        component: () => import('@/views/wiki/home.vue'),
        meta: {
          keepAlive: true,
          userSource: 'wikiHome'
        }
      },
      {
        path: 'search',
        name: 'wikiSearch',
        component: () => import('@/views/wiki/search.vue'),
        meta: {
          title: '词条搜索',
          keepAlive: false,
          userSource: 'wikiSearch'
        }
      },
      {
        path: 'detail/:entryId',
        name: 'wikiDetail',
        component: () => import('@/views/wiki/detail/index.vue'),
        meta: {
          title: '词条详情',
          keepAlive: false,
          userSource: 'wikiDetail'
        }
      },
      {
        path: 'ai-recomment/:recommentId',
        name: 'wikiAiRecomment',
        component: () => import('@/views/wiki/AIRecomment/index.vue'),
        meta: {
          title: 'AI推荐配置',
          keepAlive: false,
          userSource: 'wikiAiRecomment'
        }
      }
    ]
  },
  {
    path: '/wiki/iframe',
    name: 'wikiIframe',
    component: () => import('@/views/wiki/iframe/index.vue'),
    meta: {
      title: '词条iframe',
      keepAlive: false
    }
  }
];

export default routes;
